module.exports = __webpack_public_path__ + "img/1155883792.7ca8c056.jpg";